import type { ReactElement, ReactNode } from "react";
import { layout } from "@tokens/index";
import { PageHeader, type PageHeaderProps } from "@compositions/index";
import { adminPageStyle } from "./styles";

/**
 * AdminPage: the content column of an admin route.
 *
 * `AdminLayout` owns the chrome and the horizontal gutters. This component
 * only caps and centers the content. Single-column pages use
 * `layout.contentMaxWidth`; master-detail pages pass a wider cap.
 */

interface AdminPageProps {
    readonly maxWidth?: number;
    readonly children: ReactNode;
}

export function AdminPage({
    maxWidth = layout.contentMaxWidth,
    children,
}: AdminPageProps): ReactElement {
    return <div style={adminPageStyle(maxWidth)}>{children}</div>;
}

/** The admin name for the shared `PageHeader` grammar. */
export function AdminPageHeader(props: PageHeaderProps): ReactElement {
    return <PageHeader {...props} />;
}
